import React from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";

export const DeleteItemConfirmModal = ({
  show,
  onHide,
  onConfirm,
  isDeleting,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    backdrop="static"
    className="webedit-bottom-modal"
    dialogClassName="edit-delete-confirm-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>Delete Item?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ul className="edit-delete-confirm-list">
        <li>
          This will permanently delete this item — including the current
          result, observation and photo annotation.
        </li>
        <li>This action cannot be undone.</li>
      </ul>
    </Modal.Body>
    <Modal.Footer>
      <Button
        variant="outline-secondary"
        onClick={onHide}
        disabled={isDeleting}
      >
        Cancel
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={isDeleting}>
        {isDeleting ? (
          <>
            <Spinner animation="border" size="sm" /> Deleting...
          </>
        ) : (
          "Delete"
        )}
      </Button>
    </Modal.Footer>
  </Modal>
);

export const ModifyObsConfirmModal = ({ show, onHide, onConfirm }) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    backdrop="static"
    className="webedit-bottom-modal"
    dialogClassName="edit-modify-confirm-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>Major modification required?</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Use this only for significant changes. AI re-analysis will replace
      current result and manual edits.
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm}>
        Proceed with Update
      </Button>
    </Modal.Footer>
  </Modal>
);

export const MoveItemModal = ({
  show,
  onHide,
  onConfirm,
  isOverview,
  itemName,
  sections,
  moveSection,
  setMoveSection,
  moveSubsection,
  setMoveSubsection,
  moveSubsectionsForSection,
  moveDisabled,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    backdrop="static"
    className="webedit-bottom-modal"
    dialogClassName="edit-move-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>
        Move {isOverview ? "Overview" : itemName || "Item"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="edit-move-modal-row">
        <label className="edit-move-modal-label">
          Section <span className="edit-move-modal-required">*</span>
        </label>
        <Form.Select
          value={moveSection}
          onChange={(e) => {
            setMoveSection(e.target.value);
            setMoveSubsection("");
          }}
        >
          <option value="" disabled>
            Select a section
          </option>
          {sections.map((s) => (
            <option key={s.name} value={s.name}>
              {s.name}
            </option>
          ))}
        </Form.Select>
      </div>
      {!isOverview && (
        <div className="edit-move-modal-row">
          <label className="edit-move-modal-label">
            Subsection <span className="edit-move-modal-required">*</span>
          </label>
          <Form.Select
            value={moveSubsection}
            onChange={(e) => setMoveSubsection(e.target.value)}
            disabled={!moveSection}
          >
            <option value="" disabled>
              Select a subsection
            </option>
            {moveSubsectionsForSection.map((sub) => (
              <option key={sub.name} value={sub.name}>
                {sub.name}
              </option>
            ))}
          </Form.Select>
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onConfirm} disabled={moveDisabled}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);
